"use client";

import clsx from "clsx";
import {useEffect, useRef, useState} from "react";
import {sameOriginArtifactUrl} from "@/utils/artifactUrl";

const DocxThumbnail: React.FC<{url: string; scale?: number}> = ({url, scale = 0.35}) => {
   const containerRef = useRef<HTMLDivElement>(null);
   const [loaded, setLoaded] = useState(false);

   useEffect(() => {
      const render = async () => {
         try {
            const {renderAsync} = await import("docx-preview");
            // Wingman URLs ride the same-origin signed-in rewrite; see
            // `src/utils/artifactUrl.ts`.
            const response = await fetch(sameOriginArtifactUrl(url), {credentials: "same-origin"});
            const blob = await response.blob();
            if (containerRef.current) {
               containerRef.current.innerHTML = "";
               await renderAsync(blob, containerRef.current, undefined, {
                  className: "docx-thumb",
                  inWrapper: true,
                  ignoreWidth: false,
                  ignoreHeight: true,
               });
               setLoaded(true);
            }
         } catch (err) {
            console.warn("DOCX thumbnail render failed:", err);
         }
      };
      render();
   }, [url]);

   return (
      <div className="w-full h-full overflow-hidden">
         <div
            ref={containerRef}
            style={{width: `${Math.round(1 / scale * 100)}%`, transform: `scale(${scale})`, transformOrigin: "top left"}}
            className={clsx(
               "pointer-events-none overflow-hidden",
               "[&_.docx-wrapper]:bg-white [&_.docx-wrapper]:p-2",
               "[&_.docx-wrapper>section]:overflow-hidden",
               !loaded && "opacity-0"
            )}
         />
      </div>
   );
};

export default DocxThumbnail;
